import styled from 'styled-components';

export const Image = styled.img`
  object-fit: cover;
  width: ${({ $width }) => ($width ? `${$width}px` : 'auto')};
  height: ${({ $height }) => ($height ? `${$height}px` : 'auto')};
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'inherit')};
  aspect-ratio: ${({ $width, $height }) => ($width && $height ? $width / $height : 'auto')};
`;
